/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassModuleDisciplineConfigViewModel } from "../types/ClassModuleDisciplineConfigViewModel.ts";

export const classModuleDisciplineConfigViewModelSchema = z.object({
  classModuleId: z.optional(z.number().int()),
  disciplineId: z.optional(z.number().int()),
  showOnStudentDocument: z.optional(z.boolean()),
  isIncludedInGradeCalculation: z.optional(z.boolean()),
  isIncludedInAttendanceCalculation: z.optional(z.boolean()),
}) as unknown as ToZod<ClassModuleDisciplineConfigViewModel>;
